import {
	ArrowLongLeftIcon,
	ArrowLongRightIcon,
}                 from '@heroicons/react/20/solid';
import classNames from 'classnames';
import Link       from 'next/link';

export const paginateArticles = (articles, currentPage, perPage = 10) => {
	const pages = Math.ceil(articles.length / perPage);
	const page  = Math.max(Math.min(currentPage, pages), 1); // Clamp the current page between 1..pages

	return {
		articles:    articles.slice((page - 1) * perPage, page * perPage),
		firstPage:   1,
		lastPage:    pages,
		currentPage: page,
	};
};

export default function Pagination({
	                                              currentPage,
	                                              firstPage,
	                                              lastPage,
	                                              hrefForPage,
                                              }) {
	const specificPages = Array.from({length: lastPage - firstPage + 1}, (value, index) => {
		return {
			current: currentPage === index + 1,
			label:   index + 1,
			href:    hrefForPage(index + 1),
		};
	});

	return (<nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
		<div className="-mt-px flex w-0 flex-1">
			<Link href={hrefForPage(currentPage - 1)}
			      className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
			>
				<ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400"
				                   aria-hidden="true"
				/>
				Previous
			</Link>
		</div>
		<div className="hidden md:-mt-px md:flex">
			{specificPages.map((page) => {
				return (<Link key={page.label}
				              href={page.href}
				              aria-current={page.current}
				              className={classNames([
					              'inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium',
					              page.current ? 'border-teal-500 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
				              ])}
				>
					{page.label}
				</Link>);
			})}
		</div>
		<div className="-mt-px flex w-0 flex-1 justify-end">
			<Link
				href="#"
				className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
			>
				Next
				<ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400"
				                    aria-hidden="true"
				/>
			</Link>
		</div>
	</nav>);
}
